const Cookie = {
    get: name => {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },

    set: (name, value, options) => {
        options = options || {};
        options.path = options.path || '/';

        var expires = options.expires || 7 * 24 * 60 * 60;

        if (typeof expires === "number" && expires) {
            var d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        var updatedCookie = name + "=" + value;

        for (const propName in options) {
            if (options.hasOwnProperty(propName)) {
                updatedCookie += "; " + propName;
                const propValue = options[propName];
                if (propValue !== true) {
                    updatedCookie += "=" + propValue;
                }
            }
        }

        document.cookie = updatedCookie;
    },

    delete: name => {
        Cookie.set(name, "", {
            expires: -1
        });
    }
};

export default Cookie;